
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/feature-engineering",
      function () {
        return require("private-next-pages/cases/feature-engineering/index.tsx");
      }
    ]);
  